import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import {
  Article,
  Hub,
  QuestionAnswer,
  People,
  Bolt,
  Error as ErrorIcon,
  HourglassEmpty,
} from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';
import { mvkgTokens } from '../../theme/mvkgTokens';

const ACCENTS = {
  library: { bg: 'rgba(16, 185, 129, 0.12)', color: '#059669', Icon: Article },
  graph: { bg: 'rgba(79, 70, 229, 0.1)', color: mvkgTokens.brand.main, Icon: Hub },
  ask: { bg: 'rgba(79, 70, 229, 0.1)', color: mvkgTokens.brand.main, Icon: QuestionAnswer },
  people: { bg: 'rgba(99, 102, 241, 0.12)', color: '#4f46e5', Icon: People },
  discovery: { bg: 'rgba(245, 158, 11, 0.12)', color: '#d97706', Icon: Bolt },
  failed: { bg: 'rgba(239, 68, 68, 0.1)', color: '#dc2626', Icon: ErrorIcon },
  queued: { bg: 'rgba(245, 158, 11, 0.12)', color: '#d97706', Icon: HourglassEmpty },
};

export default function ActivityRow({ type = 'library', title, subtitle, at, avatar, onClick }) {
  const a = ACCENTS[type] || ACCENTS.library;
  const Icon = a.Icon;
  const timeLabel = at ? formatDistanceToNow(new Date(at), { addSuffix: true }) : '';

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 1.5,
        borderRadius: `${mvkgTokens.radius.md}px`,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'background 0.15s',
        '&:hover': onClick ? { bgcolor: 'rgba(255,255,255,0.85)' } : {},
      }}
    >
      {avatar ? (
        <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main', fontSize: '0.8rem' }}>{avatar}</Avatar>
      ) : (
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            bgcolor: a.bg,
            color: a.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon sx={{ fontSize: 20 }} />
        </Box>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" fontWeight={700} noWrap>
          {title}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }} noWrap>
          {subtitle}
        </Typography>
      </Box>
      {timeLabel && (
        <Typography variant="caption" color="text.secondary" sx={{ fontFamily: mvkgTokens.font.mono, flexShrink: 0 }}>
          {timeLabel}
        </Typography>
      )}
    </Box>
  );
}
